import routes from './routes'
import services from './services'
import storeModule from './store'

// O agregador (domains/store.js) faz `...store`, então exportamos um mapa
// namespaced { dynamicCalendar: <module> } — o mesmo padrão de cenario-catalogo.
const store = { dynamicCalendar: storeModule }

export { routes, services, store }
